"use client";

import { c as _c } from "react/compiler-runtime";
import QuickNoteDialog from "@/components/custom-calendar/quick-note-dialog";
import { useTenant } from "@/contexts/tenant-provider";
import { useMemoWindowStore } from "@/stores/memo-window-store";

/** The console-wide memo window opened through `useMemoWindowStore`. */
export default function GlobalMemoWindow() {
  const $ = _c(8);
  const {
    request,
    requestKey,
    closeMemoWindow
  } = useMemoWindowStore();
  const {
    tenant
  } = useTenant();
  if (!request || request.subDomain !== tenant?.subDomain) {
    return null;
  }
  let t0;
  if ($[0] !== closeMemoWindow) {
    t0 = open => !open && closeMemoWindow();
    $[0] = closeMemoWindow;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== request.event || $[3] !== request.existingNote || $[4] !== request.patient || $[5] !== requestKey || $[6] !== t0) {
    t1 = <QuickNoteDialog key={requestKey} nonModal={true} open={true} onOpenChange={t0} patient={request.patient} event={request.event} existingNote={request.existingNote} />;
    $[2] = request.event;
    $[3] = request.existingNote;
    $[4] = request.patient;
    $[5] = requestKey;
    $[6] = t0;
    $[7] = t1;
  } else {
    t1 = $[7];
  }
  return t1;
}